import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import { useSelector } from 'react-redux'
import classes from './Dialog.module.css'

export default function AlertDialog(props) {
  const count = useSelector((state) => state.counter.value)
  const successDialog = `You have just created the ${count}° invader!`

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            className={classes.dialogText}
            id="alert-dialog-description"
          >
            {props.caughtError === '' ? successDialog : props.caughtError}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={props.close} autoFocus>
            Got it!
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
